export function generateRandomNumber(min: number, max: number): number {
  if (min > max) {
    throw new Error(
      `Invalid range: min (${min}) must be less than or equal to max (${max})`
    )
  }

  return Math.floor(Math.random() * (max - min + 1)) + min
}
